(function () {
  "use strict";

  var ACCENT_COLORS = ["#ff5a5f", "#ff9f45", "#ffd23f", "#2fb6a8", "#4d96ff", "#9b5de5"];

  function accentFor(productId) {
    var index = Number(productId) % ACCENT_COLORS.length;
    return ACCENT_COLORS[index < 0 ? index + ACCENT_COLORS.length : index];
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD",
      }).format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function normalizeSrc(image) {
    var src = null;
    if (typeof image === "string") src = image;
    else if (image && image.src) src = image.src;
    if (!src) return null;
    if (src.indexOf("//") === 0) src = "https:" + src;
    if (src.indexOf("width=") === -1) {
      src += (src.indexOf("?") === -1 ? "?" : "&") + "width=800";
    }
    return src;
  }

  function mediaMarkup(image, product) {
    var src = normalizeSrc(image);
    if (src) {
      return (
        '<img src="' +
        src +
        '" alt="' +
        (product.title || "").replace(/"/g, "&quot;") +
        '" loading="lazy" class="product-detail__media-img" style="height:100%;width:100%;object-fit:cover;">'
      );
    }
    var accent = accentFor(product.id);
    return (
      '<div class="product-media-fallback"><span class="product-media-fallback__letter" style="color: ' +
      accent +
      ';">' +
      (product.title || "?").slice(0, 1) +
      "</span></div>"
    );
  }

  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var jsonEl = form.querySelector("[data-product-json]");
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantIdInput = form.querySelector("[data-product-form-variant-id]");
    var submitButton = form.querySelector("[data-product-form-submit]");
    var submitText = form.querySelector("[data-product-form-submit-text]");
    var section = form.closest("section");
    var priceEl = section ? section.querySelector('[id^="ProductPrice-"]') : null;
    var mediaEl = section ? section.querySelector('[id^="ProductMedia-"]') : null;

    function selectedOptions() {
      var groups = form.querySelectorAll("[data-option-index]");
      var options = [];
      groups.forEach(function (group) {
        var index = Number(group.getAttribute("data-option-index"));
        var checked = group.querySelector("input:checked");
        options[index] = checked ? checked.value : null;
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          return value === options[i];
        });
      });
    }

    function applyVariant(variant) {
      if (!variant) {
        if (submitButton) submitButton.disabled = true;
        if (submitText) submitText.textContent = "Unavailable";
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (mediaEl) {
        mediaEl.innerHTML = mediaMarkup(variant.featured_image || product.featured_image, product);
      }

      if (submitButton) submitButton.disabled = !variant.available;
      if (submitText) {
        submitText.textContent = variant.available ? "Add to Cart" : "Sold Out";
      }

      // Disable option values that don't exist as an available combination
      // with the currently-selected earlier options.
      var current = selectedOptions();
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        var index = Number(group.getAttribute("data-option-index"));
        group.querySelectorAll("input[data-option-value]").forEach(function (input) {
          var trial = current.slice();
          trial[index] = input.value;
          var match = findVariant(trial);
          input.disabled = !match;
        });
      });
    }

    form.addEventListener("change", function (event) {
      if (!event.target.matches("input[data-option-value]")) return;
      applyVariant(findVariant(selectedOptions()));
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (!variantIdInput || !variantIdInput.value) return;
      if (submitButton) submitButton.disabled = true;

      window.SwagbagzCart.addItem(variantIdInput.value, 1)
        .then(function () {
          if (submitText) {
            var previous = submitText.textContent;
            submitText.textContent = "Added ✓";
            window.SwagbagzCart.open();
            setTimeout(function () {
              submitText.textContent = previous === "Added ✓" ? "Add to Cart" : previous;
              if (submitButton) submitButton.disabled = false;
            }, 1500);
          } else if (submitButton) {
            submitButton.disabled = false;
          }
        })
        .catch(function () {
          if (submitButton) submitButton.disabled = false;
          if (submitText) submitText.textContent = "Couldn't add — try again";
        });
    });
  });
})();
